import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
	Row,
	Col,
	Input,
	Button,
	Space,
	Form,
	// Timeline,
	Result,
	Image,
	Card,
	Modal,
	Tooltip,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import {
	XCardsCaseBg,
	XCardsTransparent,
	XEditButtonIcon,
	XForm,
	XTag,
	XThemeButton,
	XThemeContainer,
	XThemeDetailsCards,
	XThemeModal,
	XThemeTag,
	XThemeViewUploadedDocs,
} from '../../styles/GlobalThemeStyle';
import {
	ArrowLeftOutlined,
	FilePdfOutlined,
	EyeOutlined,
} from '@ant-design/icons';
import {
	XCardBackBg,
	XButtonBack,
	XEditTitle,
	XThemeAvatarName,
	XThemMainTitle,
	XThemeAddressWrap,
	XThemeCardCaseOperations,
} from '../CaseForm/CaseFormStyle';
import { XContainer } from '../../styles/GlobalThemeStyle';
import HeaderFile from '../../components/Header/HeaderFile';
import moment from 'moment';
import {
	XTheme2Button,
} from '../../styles/GlobalThemeStyleCQ';
// actions
import {
	getUserDropdownApi,
	getUserDropdownReset,
} from '../../actions/getUserDropdownAction';
import {
	getCaseByIdApi,
	getCaseByIdReset,
} from '../../actions/getCaseByIdAction';
import { editCaseApi, editCaseReset } from '../../actions/editCaseAction';
import { addCaseApi, addCaseReset } from '../../actions/addCaseAction';
import { analyseCoverageApi } from '../../actions/analyseCoverageAction';
import { reviseCoverageApi } from '../../actions/reviseCoverageAction';
import { sendFeedbackApi } from '../../actions/sendFeedbackAction';
import {
	getAnalysisApi,
	getAnalysisReset,
} from '../../actions/getAnalysisAction';
import { checkModulePermissions, toTitleCase } from '../../utils/helper';
import {
	XDivider,
	XPara1,
	XTitleHead,
} from '../AnalyseCoverage/AnalyseCoverageStyle';
import Header from '../../components/Header/Header';
import { XButtonImg } from '../Manage/ManageStyle';
import Timeline from '../../components/HorizontalTimeline/Timeline';
import config from '../../config';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import dayjs from 'dayjs';

import { revenueCycleOptions, revenueCycleStage } from '../../utils/constants';

const CaseForm = (props) => {
	const {
		getUserDropdown,
		getCaseById,
		getCaseByIdReset,
		getCaseByIdState,
		editCaseReset,
		editCaseState,
		getAnalysisState,
		getAnalysis,
		getAnalysisReset,
	} = props;
	const navigate = useNavigate();
	const id = useParams().id;
	const [formData, setFormData] = useState({
		status: 'success',
		successful_claim_commission_criteria: 'percentage',
		successful_claim_commission_fixed_value: null,
		successful_claim_commission_percentage_value: null,
		rejected_claim_commission_criteria: 'percentage',
		rejected_claim_commission_fixed_value: null,
		rejected_claim_commission_percentage_value: null,
		case_amount: null,
		claim_amount: null,
		status_logs: [],
	});

	const [previewOpen, setPreviewOpen] = useState(false);
	const [pdfPreviewOpen, setPdfPreviewOpen] = useState(false);
	const [previewImage, setPreviewImage] = useState('');
	const [pdfWidth, setPdfWidth] = useState(700);
	const [previewTitle, setPreviewTitle] = useState('');
	const [items, setItems] = useState({});
	const [mainDataLoading, setMainDataLoading] = useState(true);

	const getBase64 = (file) =>
		new Promise((resolve, reject) => {
			const reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = () => resolve(reader.result);
			reader.onerror = (error) => reject(error);
		});

	const handleCancel = () => setPreviewOpen(false);

	const handlePreview = async (file) => {
		if (file && file.name && file.name.split('.').includes('pdf')) {
			setPreviewImage(`${config.s3_url}${file.url}` || file.preview);
			setPdfPreviewOpen(true);
		} else {
			if (!file.url && !file.preview) {
				file.preview = await getBase64(file.originFileObj);
			}
			setPreviewImage(`${config.s3_url}${file.url}` || file.preview);
			setPreviewOpen(true);
			setPreviewTitle(
				file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
			);
		}
	};

	const handleColor = (key) => {
		let color;
		switch (key) {
			case 'pending':
				color = '#E78900';
				break;
			case 'analysed':
				color = '#7A670E';
				break;
			case 'rejected':
				color = '#cf1322';
				break;
			case 'successful':
				color = '#14804a';
				break;
			case 'allocated':
				color = '#7A0E27';
				break;
			default:
				break;
		}
		return color;
	};

	// use effects
	useEffect(() => {
		if (id) getCaseById({ id: id });
		getUserDropdown();
	}, [id]);

	useEffect(() => {
		if (id) getAnalysis({ id: id });
	}, [id]);

	useEffect(() => {
		if (getCaseByIdState.apiState === 'success') {
			setMainDataLoading(false);
			setFormData({
				...getCaseByIdState.data,
				id: getCaseByIdState.data._id,
				allocated_to: getCaseByIdState.data.allocated_to?.name
					? getCaseByIdState.data.allocated_to.name
					: '-',
				organization:
					getCaseByIdState.data?.organization_detail[0]?.name,
				hospital: getCaseByIdState.data?.hospital_detail[0]?.name,
				region: getCaseByIdState.data?.region_detail[0]?.name,
				insurance_company:
					getCaseByIdState.data?.insurance_company?.name,
			});

			const tempItem = getCaseByIdState.data.status_logs.map(
				(data, i) => {
					const previousStatus =
						i > 0
							? getCaseByIdState.data.status_logs[i - 1]
									.status_updated_to
							: null;

					return {
						color: handleColor(data.status_updated_to),
						children: (
							<>
								<p>
									{moment(data.updated_at).format(
										'MMM Do, YY [at] hh:mm A',
									)}{' '}
								</p>
								<p>
									{/* {i === 0
										? `${
												data.updated_by?.name
										  } changes status to ${toTitleCase(
												data.status_updated_to,
										  )}`
										: `${
												data.updated_by?.name
										  } changed status from ${toTitleCase(
												previousStatus,
										  )} to ${toTitleCase(
												data.status_updated_to,
										  )}`} */}
								</p>
							</>
						),
					};
				},
			);

			setItems(tempItem);
			getCaseByIdReset();
		}
		if (getCaseByIdState.apiState === 'error') {
			setMainDataLoading(false);
		}
		// else if (getCaseByIdState.apiState === 'error') {
		// 	notification.error({ message: getCaseByIdState.message });
		// 	getCaseByIdReset();
		// }
	}, [getCaseByIdState]);

	useEffect(() => {
		if (editCaseState.apiState === 'success') {
			editCaseReset();
			navigate(-1);
		}
		// else if (editCaseState.apiState === 'error') {
		// 	notification.error({ message: editCaseState.message });
		// }
	}, [editCaseState]);

	return (
		<>
			{props.displayHeader ? (
				<></>
			) : (
				<>
					<Col lg={24} xl={24} xs={0} md={0}>
						<Header headerTag="Case Management" />
					</Col>
					<Col lg={0} xl={0} xs={24} md={24}>
						<HeaderFile activeNav="caseManagement" />
					</Col>
				</>
			)}

			<XThemeContainer fluid className="mt-3">
				{checkModulePermissions('case-management').sub_modules.includes(
					'view-cases',
				) ? (
					<>
						{/* <XCardBackBg className="mb-3">
							<Row>
								<Col xs={20}>
									<XButtonBack
										onClick={() => navigate(-1)}
										icon={<ArrowLeftOutlined />}
										size="large"
									/>

									<XEditTitle>View Cases</XEditTitle>
								</Col>
								<Col
									xs={{ span: 1, offset: 1 }}
									md={{ span: 1, offset: 2 }}
									lg={{ span: 1, offset: 3 }}
									xl={{ span: 1, offset: 3 }}
								>
									<XButtonImg
										onClick={() =>
											navigate(`/case/edit/${id}`)
										}
										type="text"
									>
										<img src="/images/pencil.svg" alt="" />
									</XButtonImg>
								</Col>
							</Row>
						</XCardBackBg> */}
						{/* <XCardsTransparent></XCardsTransparent> */}
						<XThemeCardCaseOperations
							className="largePadding mb-3"
							loading={mainDataLoading}
						>
							<Row
								gutter={(15, 15)}
								className="align-items-center"
							>
								<Col xs={12}>
									<Space>
										<XThemeAvatarName gap="4">
											{formData.patient_first_name &&
												formData?.patient_first_name[0]}
											{formData.patient_last_name &&
												formData?.patient_last_name[0]}
										</XThemeAvatarName>
										<XThemMainTitle>
											{formData.patient_first_name}{' '}
											{formData.patient_last_name}
											<br />
											<span>{formData.mrn}</span>
										</XThemMainTitle>
									</Space>
									{/* <label className="headerStyle me-4">
										{formData.patient_first_name}
										{formData.patient_last_name}
									</label> */}

									{/* <br />
									<span className="mt-2">{formData.mrn}</span> */}
								</Col>
								<Col xs={12} className="text-end">
									<Space>
										<XThemeTag className={formData.status}>
											{formData.status
												? toTitleCase(formData.status)
												: ''}
										</XThemeTag>
										<XTheme2Button
											className="backgroundRevers px-4"
											onClick={() =>
												navigate(`/case/edit/${id}`)
											}
											type="text"
										>
											Edit
										</XTheme2Button>
									</Space>
								</Col>
							</Row>
							{formData.treatment_date ? (
								<Row
									gutter={[15, 15]}
									className="align-items-center"
								>
									<Col xl={6} lg={6}>
										<XThemMainTitle className="mt-3">
											Treatment Date :&nbsp;
											<span style={{ fontWeight: 500 }}>
												{moment(
													formData.treatment_date,
												).format('MMMM Do, YYYY')}
											</span>
										</XThemMainTitle>
									</Col>
								</Row>
							) : (
								''
							)}
							<Form layout="vertical" className="mt-3">
								<XThemeAddressWrap className="mb-3">
									<Row gutter={[15, 0]}>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Gender <br />
												<span>
													{formData.gender
														? toTitleCase(
																formData.gender,
														  )
														: ''}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Date Of Birth <br />
												<span>
													{moment(
														formData.date_of_birth,
													).format('MMMM Do, YYYY')}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Age <br />
												<span>
													{moment(
														formData.date_of_birth,
													).fromNow(true)}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Organization <br />
												<span>
													{formData.organization}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Hospital <br />
												<span>{formData.hospital}</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Region
												<br />
												<span>{formData.region}</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Visit Type <br />
												<span>
													{formData.visit_type}
												</span>
											</div>
										</Col>
										{formData.date_of_eob && (
											<Col xs={24} sm={12} md={8} lg={6}>
												<div className="heading">
													EOB Date <br />
													<span>
														{formData.date_of_eob
															? moment(
																	formData.date_of_eob,
															  ).format(
																	'MMMM Do, YYYY',
															  )
															: '-'}
													</span>
												</div>
											</Col>
										)}
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Admission Date
												<br />
												<span>
													{formData.date_of_admission
														? moment(
																formData.date_of_admission,
														  ).format(
																'MMMM Do, YYYY',
														  )
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Discharge Date <br />
												<span>
													{formData.date_of_discharge
														? moment(
																formData.date_of_discharge,
														  ).format(
																'MMMM Do, YYYY',
														  )
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Hearing Date
												<br />
												<span>
													{formData.hearing_date
														? moment(
																formData.hearing_date,
														  ).format(
																'MMMM Do, YYYY',
														  )
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												State
												<br />
												<span>{formData.state}</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Insurance Company
												<br />
												<span>
													{formData.insurance_company}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Allocated To
												<br />
												<span>
													{formData.allocated_to
														? formData.allocated_to
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Claim Amount
												<br />
												<span>
													{formData.claim_amount
														? '$'
														: ''}{' '}
													{formData.claim_amount
														? formData.claim_amount
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Case Amount
												<br />
												<span>
													{formData.case_amount
														? `$${formData.case_amount}`
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Process Type
												<br />
												<span>
													{formData.process_type}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Revenue Cycle
												<br />
												<span>
													{formData.revenue_cycle &&
														revenueCycleOptions.map(
															(val, i) => {
																if (
																	val.value ===
																	formData.revenue_cycle
																) {
																	return val.label;
																}
																return null;
															},
														)}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Revenue Cycle Stage <br />
												<span>
													{formData.revenue_cycle_stage &&
														revenueCycleStage.map(
															(val, i) => {
																if (
																	val.value ===
																	formData.revenue_cycle_stage
																) {
																	return val.label;
																}
																return null;
															},
														)}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Created On <br />
												<span>
													{moment(
														formData.createdAt,
													).format('MMMM Do, YYYY')}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Last Date
												<br />
												<span>
													{moment(
														formData.updatedAt,
													).format('MMMM Do, YYYY')}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Insurance claim number <br />
												<span>
													{formData.insurance_claim_number
														? formData.insurance_claim_number
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24} sm={12} md={8} lg={6}>
											<div className="heading">
												Providers Encounter number{' '}
												<br />
												<span>
													{formData.providers_encounter_number
														? formData.providers_encounter_number
														: '-'}
												</span>
											</div>
										</Col>
										<Col xs={24}>
											<div className="heading">
												Date of Service <br />
												<span>
													{/* Display single dates if available */}
													{formData.date_of_service
														?.single_date?.length >
														0 && (
														<>
															{formData.date_of_service.single_date.map(
																(
																	date,
																	index,
																) => (
																	<span
																		key={
																			index
																		}
																	>
																		{moment(
																			date,
																		).format(
																			'MMMM Do, YYYY',
																		)}
																		{index <
																			formData
																				.date_of_service
																				.single_date
																				.length -
																				1 &&
																			', '}
																	</span>
																),
															)}
														</>
													)}
													{/* Display a separator if both single dates and date ranges exist */}
													{formData.date_of_service
														?.single_date?.length >
														0 &&
														formData.date_of_service
															?.date_range
															?.length > 0 &&
														', '}
													{/* Display date ranges if available */}
													{formData.date_of_service
														?.date_range?.length >
														0 && (
														<>
															{formData.date_of_service.date_range.map(
																(
																	range,
																	index,
																) => (
																	<span
																		key={
																			index
																		}
																	>
																		{range[0]
																			? moment(
																					range[0],
																			  ).format(
																					'MMMM Do, YYYY',
																			  )
																			: ''}
																		{' to '}
																		{range[1]
																			? moment(
																					range[1],
																			  ).format(
																					'MMMM Do, YYYY',
																			  )
																			: ''}
																		{index <
																			formData
																				.date_of_service
																				.date_range
																				.length -
																				1 &&
																			', '}
																	</span>
																),
															)}
														</>
													)}
													{/* Placeholder if no dates are selected */}
													{!(
														formData.date_of_service
															?.single_date
															?.length > 0 ||
														formData.date_of_service
															?.date_range
															?.length > 0
													) && '-'}
												</span>
											</div>
										</Col>
									</Row>
								</XThemeAddressWrap>
								<XThemeAddressWrap className="mb-3">
									<div className="heading">
										<strong>Clinical Summary</strong>
									</div>
									<Row
										gutter={(15, 15)}
										className="align-items-center"
									>
										{formData.clinical_docs &&
										formData.clinical_docs.length > 0 ? (
											<>
												{formData.clinical_docs.length >
													0 &&
													formData.clinical_docs.map(
														(ele) => {
															return (
																<Col
																	xs={24}
																	sm={12}
																	lg={6}
																	className="mb-3"
																>
																	<div className="image-container_case_filing">
																		{ele.url.name
																			.split(
																				'.',
																			)
																			.includes(
																				'pdf',
																			) ? (
																			<>
																				<XThemeViewUploadedDocs
																					hoverable
																					onClick={() =>
																						handlePreview(
																							ele.url,
																						)
																					}
																				>
																					<Space>
																						<img
																							className="img-fluid"
																							src="/images/new-pdf.svg"
																							alt="pdf"
																						/>
																						{
																							ele
																								.url
																								.name
																						}
																					</Space>
																					<div className="overlay_case_filing">
																						<EyeOutlined
																							onClick={() =>
																								handlePreview(
																									ele.url,
																								)
																							}
																							className="icon eye-icon"
																						/>
																					</div>
																				</XThemeViewUploadedDocs>
																			</>
																		) : (
																			<div className="image-container_case_filing">
																				<XThemeViewUploadedDocs>
																					<Image
																						className="supporting-docs-hover"
																						src={`${config.s3_url}${ele.url.url}`}
																						onClick={() =>
																							handlePreview(
																								ele.url,
																							)
																						}
																					/>
																					{
																						ele
																							.url
																							.name
																					}
																					<div className="overlay_case_filing">
																						<EyeOutlined
																							onClick={() =>
																								handlePreview(
																									ele.url,
																								)
																							}
																							className="icon eye-icon"
																						/>
																					</div>
																				</XThemeViewUploadedDocs>
																			</div>
																		)}
																	</div>
																</Col>
															);
														},
													)}
											</>
										) : (
											<Col xs={24}>
												<div class="para text-justify">
													{formData.clinical_summary}
												</div>
											</Col>
										)}
									</Row>
								</XThemeAddressWrap>

								{/* supporting docs */}
								{formData.supporting_docs &&
									formData.supporting_docs.length > 0 && (
										<XThemeAddressWrap>
											<div className="heading">
												<strong>
													Supporting Documents
												</strong>
											</div>
											<Row
												gutter={(15, 15)}
												className="align-items-center"
											>
												<>
													{formData.supporting_docs &&
														formData.supporting_docs
															.length > 0 &&
														formData.supporting_docs.map(
															(ele) => {
																return (
																	<Col
																		xs={24}
																		sm={12}
																		lg={6}
																		className="mb-3"
																	>
																		{ele.url.name
																			.split(
																				'.',
																			)
																			.includes(
																				'pdf',
																			) ? (
																			<>
																				<div className="image-container_case_filing">
																					<XThemeViewUploadedDocs
																						hoverable
																						onClick={() =>
																							handlePreview(
																								ele.url,
																							)
																						}
																					>
																						<Space>
																							<img
																								className="img-fluid"
																								src="/images/new-pdf.svg"
																								alt="pdf"
																							/>
																							{
																								ele.document_name
																							}
																						</Space>
																						<div className="overlay_case_filing">
																							<EyeOutlined
																								onClick={() =>
																									handlePreview(
																										ele.url,
																									)
																								}
																								className="icon eye-icon"
																							/>
																						</div>
																					</XThemeViewUploadedDocs>
																				</div>
																			</>
																		) : (
																			<>
																				<div className="image-container_case_filing">
																					<XThemeViewUploadedDocs>
																						<Image
																							className="supporting-docs-hover"
																							src={`${config.s3_url}${ele.url.url}`}
																							onClick={() =>
																								handlePreview(
																									ele.url,
																								)
																							}
																						/>
																						{
																							ele.document_name
																						}
																						<div className="overlay_case_filing">
																							<EyeOutlined
																								onClick={() =>
																									handlePreview(
																										ele.url,
																									)
																								}
																								className="icon eye-icon"
																							/>
																						</div>
																					</XThemeViewUploadedDocs>
																				</div>
																			</>
																		)}
																	</Col>
																);
															},
														)}
												</>
											</Row>
										</XThemeAddressWrap>
									)}
							</Form>
						</XThemeCardCaseOperations>
					</>
				) : (
					<Result
						status="403"
						title="403"
						subTitle="Sorry, you are not authorized to access this page."
						extra={
							<Button
								type="primary"
								onClick={() => navigate('/')}
							>
								Back Home
							</Button>
						}
					/>
				)}
			</XThemeContainer>
			{/* Modal for preview */}
			<XThemeModal
				open={previewOpen}
				title={previewTitle}
				footer={null}
				onCancel={handleCancel}
			>
				{previewImage ? (
					<img
						alt="example"
						style={{
							width: '100%',
						}}
						src={previewImage}
					/>
				) : null}
			</XThemeModal>
			<XThemeModal
				open={pdfPreviewOpen}
				title="Preview"
				footer={null}
				onCancel={() => setPdfPreviewOpen(false)}
				width={pdfWidth} // Set the width of the modal dynamically
			>
				<div>
					<Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
						<div
							style={{
								height: '750px',
							}}
						>
							<Viewer fileUrl={previewImage} />
						</div>
					</Worker>
				</div>
			</XThemeModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	getUserDropdownState: state.getUserDropdown,
	getCaseByIdState: state.getCaseById,
	editCaseState: state.editCase,
	addCaseState: state.addCase,
	analyseCoverageState: state.analyseCoverage,
	reviseCoverageState: state.reviseCoverage,
	sendFeedbackState: state.sendFeedback,
	getAnalysisState: state.getAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
	getUserDropdown: () => dispatch(getUserDropdownApi()),
	getUserDropdownReset: () => dispatch(getUserDropdownReset()),
	getCaseById: (data) => dispatch(getCaseByIdApi(data)),
	getCaseByIdReset: () => dispatch(getCaseByIdReset()),
	editCase: (data) => dispatch(editCaseApi(data)),
	editCaseReset: () => dispatch(editCaseReset()),
	addCase: (data) => dispatch(addCaseApi(data)),
	addCaseReset: () => dispatch(addCaseReset()),
	analyseCoverage: (params) => dispatch(analyseCoverageApi(params)),
	reviseCoverage: (params) => dispatch(reviseCoverageApi(params)),
	sendFeedback: (params) => dispatch(sendFeedbackApi(params)),
	getAnalysis: (params) => dispatch(getAnalysisApi(params)),
	getAnalysisReset: (params) => dispatch(getAnalysisReset(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CaseForm);
